import { create } from 'zustand';
import { cdnBase } from './config';

interface UploadedState {
  ids: Record<string, true>;
}

const useUploaded = create<UploadedState>(() => ({ ids: {} }));

export function cloudUrl(id: string, params?: string): string {
  return `${cdnBase()}/a/${id}${params ? `?${params}` : ''}`;
}

export function isUploaded(id: string): boolean {
  return !!useUploaded.getState().ids[id];
}

export function markUploaded(id: string): void {
  useUploaded.setState((s) => ({ ids: { ...s.ids, [id]: true } }));
}

export function resetUploaded(): void {
  useUploaded.setState({ ids: {} });
}
